module.exports = __webpack_public_path__ + "img/602-42dfb3.png";